import { VALID_CARE_PLANS_DISCOUNTS } from "@src/constants";
import { cacheUtils } from "@src/index";
import { CacheTypes } from "@src/utilities/cache/interfaces";
import { useAppSelector } from "@store/hooks";
import { removePromoCodeDiscount } from "@utils/charges";
import React, { useMemo } from "react";
import useDebugInformation from "../../../../../../../../hooks/useDebugInformation";
import { validCarePlansDiscounts } from "./discountsLogic";

export const useDiscounts = (parent: string) => {
    const prefix = "Rates";
    const charge = useAppSelector(({ state }) => state.Charge);
    const rateReason = useAppSelector(({ ui }) => ui.RatesRateReason);
    const rateDiscount = useAppSelector(({ ui }) => ui.RatesDiscount);
    const promoCode = useAppSelector(({ ui }) => ui.PromoCode);
    const promoCodeApplied = useAppSelector(({ state }) => state.PromoCodeApplied);
    const promoCodeValid = useAppSelector(({ state }) => state.PromoCodeValid);
    const isCapped = useAppSelector(({ state }) => state.IsCapped);
    const isFixedPrice = useAppSelector(({ state }) => state.IsFixedPrice);
    const priceCap = useAppSelector(({ state }) => state.PriceCap);
    const discount = useAppSelector(({ state }) => state.Discount);
    const serviceAgreementReference = useAppSelector(({ ui }) => ui.CarePlanReference);
    const jobTypeCode = useAppSelector(({ state }) => state.JobTypeCode);

    const debugName = `${parent}▷[DiscountsTab]`;

    React.useEffect(() => {
        if (!promoCodeValid && promoCodeApplied) {
            removePromoCodeDiscount();
        }
    }, [promoCodeApplied, promoCodeValid]);

    useDebugInformation(debugName, {
        charge,
        rateReason,
        rateDiscount,
        promoCode,
        promoCodeApplied,
        promoCodeValid,
        isCapped,
        isFixedPrice,
        priceCap,
        discount,
        serviceAgreementReference
    });

    const discountOptions = useMemo(() => {
        const allDiscounts = cacheUtils.getCache<CacheTypes.DiscountTypes>("DiscountTypes");
        const validCCPlansDiscounts = validCarePlansDiscounts(jobTypeCode);
        console.log("validCCPlansDiscounts", validCCPlansDiscounts);
        console.log("allDiscounts", allDiscounts);
        return serviceAgreementReference
            ? allDiscounts.filter(x => validCCPlansDiscounts.includes(x.discountId || 0)) // After Sale include only valid CC discounts
            : allDiscounts.filter(x => !VALID_CARE_PLANS_DISCOUNTS.includes(x.discountId || 0)); // Before sale do not show any CC discounts, applied automatically
    }, [jobTypeCode, serviceAgreementReference]);

    return {
        prefix,
        charge,
        rateReason,
        rateDiscount,
        promoCode,
        promoCodeApplied,
        promoCodeValid,
        isCapped,
        isFixedPrice,
        priceCap,
        discount,
        serviceAgreementReference,
        discountOptions
    };
};